const initialState = {
    menus: JSON.parse(localStorage.getItem("menus")) || [],
    openKeys: JSON.parse(localStorage.getItem("openKeys")) || [],
}
export const menuReducer = (prevState = initialState, action) => {
    let newState = { ...prevState }
    if (action.type === "setMenus") {
        newState.menus = action.data
        localStorage.setItem("menus", JSON.stringify(action.data))
    }
    if (action.type === "setOpenKeys") {
        newState.openKeys = action.data
        localStorage.setItem("openKeys", JSON.stringify(action.data))
    }
    return newState
}